export const learningCenterData = {
  sections: [
    {
      id: "mls-data-sqe",
      title: "MLS data using the Sidekick Query Engine",
      videos: [
        { id: "e603cdf2626f4effa2ac5589a3aeb0b0" },
        { id: "c4e64acfe39b4ac78b714b9e92fe02c1" },
        { id: "decaf5a7968142e5925f5f070e8dcfa7" },
        { id: "0ef5b41e2cfd4b35b479b0f66dbd12bb" },
        { id: "73055bf0fa714c31befa69e4a84b2075" },
      ],
    },
    {
      id: "marketing",
      title: "Marketing",
      videos: [{ id: "154a5bb2707c4a8f828084d6791f7391" }],
    },
    {
      id: "cma-tutorials",
      title: "CMA Tutorials",
      videos: [
        { id: "177fe16f24324841901588a44b697de2" },
        { id: "b7d1948e26794c9b97739bd20d4ec84e" },
        { id: "c4a27859b54d4abfb6da388564063b65" },
        { id: "ade217d9bb0349c29713b3883df82687" },
        { id: "fbfa3afca6214d2c99fa9a38e5db6e46" },
      ],
    },
  ],
};

export const allVideoIds = learningCenterData.sections.flatMap((section) =>
  section.videos.map((video) => video.id)
);

const LOOM_BASE_URL = `https://www.loom.com`;

export const buildLoomShareUrl = (videoId: string) =>
  `${LOOM_BASE_URL}/share/${videoId}`;

export const buildLoomEmbedUrl = (videoId: string): string => {
  const queryParams = {
    hide_share: "true",
    hideEmbedTopBar: "true",
    hide_title: "true",
    hide_owner: "true",
    hide_speed: "true",
    autoplay: "false",
  };

  const urlObject = new URL(`${LOOM_BASE_URL}/embed/${videoId}`);

  Object.entries(queryParams).forEach(([key, value]) => {
    urlObject.searchParams.set(key, value);
  });

  return urlObject.toString();
};
